import type { FileInputProps } from "@mantine/core";
import { Center, Group } from "@mantine/core";
import { MdImage } from "react-icons/md";

const Value = ({ file }: { file: File | null }) => {
  return (
    <Center
      sx={(theme) => {
        return {
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[7]
              : theme.colors.gray[1],
          borderRadius: theme.radius.sm,
          fontSize: theme.fontSizes.xs,
          padding: "3px 7px",
        };
      }}
    >
      <MdImage size={14} style={{ marginRight: 5 }} />
      <span
        style={{
          display: "inline-block",
          maxWidth: 200,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {file?.name}
      </span>
    </Center>
  );
};

export const ImageValueComponent: FileInputProps["valueComponent"] = ({
  value,
}) => {
  if (Array.isArray(value)) {
    return (
      <Group spacing="sm" py="xs">
        {value.map((file, index) => {
          return <Value file={file} key={index} />;
        })}
      </Group>
    );
  }

  return <Value file={value} />;
};
